import { GridBreakpoint } from '../grid-form/grid-form.component';

export const RESPONSIVE_BREAKPOINTS: GridBreakpoint[] = [
  { minWidth: 1280, columns: 4, gap: '1.5rem', autoFit: true },
  { minWidth: 1024, maxWidth: 1279, columns: 3, gap: '1.25rem', autoFit: true },
  { minWidth: 768, maxWidth: 1023, columns: 2, gap: '1rem', autoFit: true },
  { maxWidth: 767, columns: 1, gap: '0.75rem', autoFit: true },
];

export const FIXED_4_COLUMNS: GridBreakpoint[] = [
  { minWidth: 0, columns: 4, gap: '1.5rem', autoFit: false },
];

export const FIXED_3_COLUMNS: GridBreakpoint[] = [
  { minWidth: 0, columns: 3, gap: '1.5rem', autoFit: false },
];

export const FIXED_2_COLUMNS: GridBreakpoint[] = [
  { minWidth: 0, columns: 2, gap: '1.5rem', autoFit: false },
];

export const HYBRID_BREAKPOINTS: GridBreakpoint[] = [
  { minWidth: 1024, columns: 4, gap: '1.5rem', autoFit: true },
  { minWidth: 768, maxWidth: 1023, columns: 3, gap: '1.25rem', autoFit: true },
  { maxWidth: 767, columns: 2, gap: '1rem', autoFit: true },
];

export const DENSE_RESPONSIVE: GridBreakpoint[] = [
  { minWidth: 1440, columns: 6, gap: '1rem', autoFit: false },
  { minWidth: 1024, maxWidth: 1439, columns: 4, gap: '1rem', autoFit: false },
  { minWidth: 768, maxWidth: 1023, columns: 3, gap: '0.75rem', autoFit: false },
  { maxWidth: 767, columns: 1, gap: '0.75rem', autoFit: false },
];

export const SIMPLE_RESPONSIVE: GridBreakpoint[] = [
  { minWidth: 1024, columns: 2, gap: '1.5rem', autoFit: true },
  { minWidth: 768, maxWidth: 1023, columns: 2, gap: '1rem', autoFit: true },
  { maxWidth: 767, columns: 1, gap: '0.75rem', autoFit: true },
];
